import { ApiGatewayResponse, HttpStatusCode } from '@/api/ApiGateway.js'

/**
 * Use to create validation errors client side.
 */
export default class Validation
{
	errors = null

	constructor ()
	{
		this.errors = new ApiGatewayResponse({
			'status': HttpStatusCode.ValidationError,
			'response': {
				'data': {
					'errors': []
				}
			}
		}, null)
	}

	/**
	 * Add an error
	 * @param p_id {string} Id in the error-field attribute of the field
	 * @param p_message Message to show
	 */
	add(p_id, p_message)
	{
		const errs = this.errors.error.response.data.errors;
		const err = errs.find(p_item => p_item.source === p_id)
		if (err)
		{
			err.detail += "\n" + p_message //Allows multiple errors to be shown for a field at once
		}
		else
		{
			errs.push(
				{
					'title': 'Invalid value',
					'status': 422,
					'detail': p_message,
					'source': p_id
				}
			);
		}
	}

	/**
	 * Remove an error with a specific id
	 * @param p_id
	 */
	remove(p_id)
	{
		if (p_id)
		{
			const errs = this.errors.error.response.data.errors;
			const index = errs.findIndex(p_item => p_item.source === p_id)
			if (index > -1)
			{
				errs.splice(index, 1);
			}
		}
	}

	/**
	 * Remove all errors
	 */
	removeAll()
	{
		this.errors.error.response.data.errors = [];
	}

	/**
	 *
	 * @returns the number of errors
	 */
	count()
	{
		return this.errors.error.response.data.errors.length
	}
}